(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/components/draw-selector-list.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/components/draw-selector-list.js');

'use strict';

const {
  DrawSelectorItem
} = svs.sport.drawSelectorAssets;
class DrawSelectorList extends React.Component {
  componentDidUpdate() {
    if (this.props.onToggle) {
      this.props.onToggle();
    }
  }
  render() {
    const {
      showList,
      draws,
      onChangeDrawHandler,
      selectedDraw
    } = this.props;
    if (!showList) {
      return null;
    }
    const items = draws.map(draw => React.createElement(DrawSelectorItem, {
      draw: draw,
      isSelected: selectedDraw === draw.drawNumber,
      key: draw.drawNumber,
      onHandleClick: onChangeDrawHandler
    }));
    return React.createElement("div", {
      className: "panel panel-default panel-drawselector",
      id: "draw-selector-list"
    }, React.createElement("ul", {
      className: "list-group"
    }, items));
  }
}
setGlobal('svs.sport.drawSelectorAssets.DrawSelectorList', DrawSelectorList);

 })(window);